export default __webpack_public_path__ + "media/d32098e4cb8b7a5b70dbb42b7417cb59e9248da7a9000951539efd744cf2beba.svg";